import { facadeApi } from 'api'
import { HierarchyTree } from 'types/hierarchy/hierarchy'

export const fetchHierarchyTreeApi = ({ tenantId }: { tenantId: string }) =>
  facadeApi.get<HierarchyTree>(`/v2/tenants/${tenantId}/hierarchy-tree`)
